import { render, staticRenderFns } from "./contactCenSqzx.vue?vue&type=template&id=abccbeb0&scoped=true&"
import script from "./contactCenSqzx.vue?vue&type=script&lang=js&"
export * from "./contactCenSqzx.vue?vue&type=script&lang=js&"
import style1 from "./contactCenSqzx.vue?vue&type=style&index=1&id=abccbeb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abccbeb0",
  null
  
)

export default component.exports